import React from 'react';

/*
    Label Input

    This is a custom component for the custom drawer, is a label component next to an input component. This can be used to 
    display a label next to an input field, where the input field can be used to input data. Example of usage is in the 
    EntitySettings component where the user can input the positionan entity. To create a list of elements of this type, use
    the LabelInputList component.
*/

function LabelInput({ labelName, inputInfo}) {

    return (
        <div className="flex items-center justify-between h-7 box-border gap-3 mt-4 mb-2" id="label-input__container">
        <label className="font-medium text-lg text-left text-color-bua-text-light overflow-hidden text-ellipsis whitespace-nowrap w-full" id="label-input__container__label">
            {labelName}
        </label>
        {inputInfo.map((input, index) => (
                <input 
                    key={index}
                    id={`inputField${index}`} 
                    type={input.inputType || "text"}
                    defaultValue={input.inputDefault} 
                    value={input.inputValue}
                    onChange={e => input.inputCallback(e.target.value)} 
                    step={input.inputStep || "1"} 
                    min={input.inputType === "number" && input.inputMinimum ? input.inputMinimum : undefined}
                    max={input.inputType === "number" && input.inputMaximum ? input.inputMaximum : undefined}
                    className='bg-color-bua-background-light text-sm text-color-bua-text-light border-2 border-color-bua-background rounded-lg w-1/2 h-7 px-2 text-center'
                    style={{ height: '70%', width: '40%', cursor: "pointer" }} 
                />
            ))}
        </div>
    );
}

export default LabelInput;